/**
 * @generated SignedSource<<768379bf60c384d0494e13b836ac6cab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type documentsTableRowFragment$data = {
  readonly documentDownloadUrlCookieAuth: string | null | undefined;
  readonly documentName: string | null | undefined;
  readonly documentTypeName: string | null | undefined;
  readonly grantedDate: any | null | undefined;
  readonly id: string;
  readonly propertyOverviewUrl: string | null | undefined;
  readonly readDate: any | null | undefined;
  readonly " $fragmentType": "documentsTableRowFragment";
};
export type documentsTableRowFragment$key = {
  readonly " $data"?: documentsTableRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"documentsTableRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "documentsTableRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "inline",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "previewState",
          "value": "FullVersion"
        }
      ],
      "kind": "ScalarField",
      "name": "documentDownloadUrlCookieAuth",
      "storageKey": "documentDownloadUrlCookieAuth(inline:false,previewState:\"FullVersion\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "propertyOverviewUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentTypeName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "readDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "grantedDate",
      "storageKey": null
    }
  ],
  "type": "Document",
  "abstractKey": null
};

(node as any).hash = "a9f9d99d7803e186fdc62496ebc8af8e";

export default node;
